import { render, staticRenderFns } from "./CartLogin.vue?vue&type=template&id=1670caac&scoped=true"
import script from "./CartLogin.vue?vue&type=script&lang=js"
export * from "./CartLogin.vue?vue&type=script&lang=js"
import style0 from "./CartLogin.vue?vue&type=style&index=0&id=1670caac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670caac",
  null
  
)

export default component.exports